// extracted by mini-css-extract-plugin
module.exports = {"container":"CredentialConfig_container_24lSK"};